module.exports = __webpack_public_path__ + "media/Shva_talk.4fa5d045.mp3";